//LAZY LOAD
document.addEventListener("DOMContentLoaded", function() {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
if ("IntersectionObserver" in window) {
  let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        let lazyImage = entry.target;
        lazyImage.src = lazyImage.dataset.src;
        lazyImage.classList.remove("lazy");
        lazyImageObserver.unobserve(lazyImage);
         }
     });
      });
  lazyImages.forEach(function(lazyImage) {
    lazyImageObserver.observe(lazyImage);
  });
  }
});

//ROOT HEIGHT ELEMENTS
document.addEventListener('DOMContentLoaded', function(){
    var w = window.innerWidth,
    h = window.innerHeight;

    document.documentElement.style.setProperty('--h', h + 'px');

    b = document.getElementById("header").offsetHeight;
    document.documentElement.style.setProperty('--nav', b + 'px');
});

//ON RESIZE
window.addEventListener("resize", onResizeFunction);
function onResizeFunction (e){
var w = window.innerWidth,
h = window.innerHeight;
document.documentElement.style.setProperty('--h', h + 'px');

b = document.getElementById("header").offsetHeight;
document.documentElement.style.setProperty('--nav', b + 'px');

}


function setupHeaderNavigation() {
  var $toggle = $('.site-header__toggle');
  var $nav = $('#site-nav');

  if (!$toggle.length || !$nav.length) {
    return;
  }

  function openNav() {
    $nav.addClass('is-open');
    $('body').addClass('nav-open');
    $toggle.attr('aria-expanded', 'true').text('CLOSE');
    $nav.attr('aria-hidden', 'false');

    $('.main').hide();
    $('#cart-wrapper').hide();
  }

  function closeNav() {
    $nav.removeClass('is-open');
    $('body').removeClass('nav-open');
    $toggle.attr('aria-expanded', 'false').text('MENU');
    $nav.attr('aria-hidden', 'true');
    $('.main').show();
    $('#cart-wrapper').show();
  }

  $toggle.on('click', function() {
    if ($nav.hasClass('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' && $nav.hasClass('is-open')) {
      closeNav();
      $toggle.trigger('focus');
    }
  });

  $nav.find('a').on('click', function() {
    if (window.matchMedia('(max-width: 768px)').matches) {
      closeNav();
    }
  });

  function syncNavState() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      closeNav();
    }
  }

  syncNavState();
  $(window).on('resize', syncNavState);
}

$(document).ready(function() {

  $("button#add-to-cart").click(function(){
    $(".product-added").addClass("active");

    setTimeout(function() {
      $(".product-added").removeClass("active");
  }, 6000); // 2000 milisegundos = 2 segundos
  });

  $(".free-shippping .closer").click(function(){
    $(".free-shippping").hide();
  });

  $(".cookies .closer").click(function(){
    $(".cookies").hide();
  });

  setupHeaderNavigation();

  $("body").addClass("active");

});

function getYouTubeVideoId(url) {
  if (!url) {
    return null;
  }
  var idMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  return idMatch ? idMatch[1] : null;
}

function initMediaGridSections(context) {
  var scope = context || document;
  var sections = scope.querySelectorAll('.media-grid-section[data-section-type="media-grid"]');

  if (!sections.length) {
    return;
  }

  sections.forEach(function(section) {
    var videoCards = section.querySelectorAll('.media-card--video');

    videoCards.forEach(function(card) {
      var playButton = card.querySelector('.media-card__play-button');
      var mediaInner = card.querySelector('.media-card__media-inner');
      var autoplay = card.getAttribute('data-video-autoplay') === 'true';

      if (!mediaInner) {
        return;
      }

      // Función para cargar y reproducir el video
      var loadVideo = function() {
        if (card.classList.contains('media-card--video-active')) {
          return;
        }

        var videoSource = card.getAttribute('data-video-source');
        var youtubeUrl = card.getAttribute('data-youtube-url');
        var mp4Url = card.getAttribute('data-mp4-url');
        var loop = card.getAttribute('data-video-loop') === 'true';
        var muted = card.getAttribute('data-video-muted') === 'true';
        var playerEl = null;

        if (videoSource === 'youtube') {
          var videoId = getYouTubeVideoId(youtubeUrl);

          if (!videoId) {
            console.warn('No se pudo obtener el ID de YouTube para el card:', card);
            return;
          }

          var embedUrl = new URL('https://www.youtube.com/embed/' + videoId);
          embedUrl.searchParams.set('autoplay', '1');
          embedUrl.searchParams.set('rel', '0');
          embedUrl.searchParams.set('controls', '0');

          if (muted) {
            embedUrl.searchParams.set('mute', '1');
          }

          if (loop) {
            embedUrl.searchParams.set('loop', '1');
            embedUrl.searchParams.set('playlist', videoId);
          }

          playerEl = document.createElement('iframe');
          playerEl.className = 'media-card__video-embed';
          playerEl.src = embedUrl.toString();
          playerEl.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
          playerEl.setAttribute('allowfullscreen', 'true');
          playerEl.setAttribute('title', 'Video de YouTube');
        } else if (videoSource === 'mp4') {
          if (!mp4Url) {
            console.warn('No se configuró un MP4 para el card:', card);
            return;
          }

          playerEl = document.createElement('video');
          playerEl.className = 'media-card__video-element';
          playerEl.setAttribute('playsinline', '');
          playerEl.src = mp4Url;
          playerEl.setAttribute('autoplay', '');

          if (loop) {
            playerEl.setAttribute('loop', '');
          }

          if (muted) {
            playerEl.muted = true;
          }
        }

        if (!playerEl) {
          return;
        }

        card.classList.add('media-card--video-active');
        mediaInner.innerHTML = '';
        mediaInner.appendChild(playerEl);

        if (videoSource === 'mp4') {
          var playPromise = playerEl.play();
          if (playPromise !== undefined) {
            playPromise.catch(function() {
              // Ignorar si el navegador bloquea la reproducción automática
            });
          }
        }
      };

      // Si tiene autoplay, usar Intersection Observer para reproducir cuando sea visible
      if (autoplay) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && !card.classList.contains('media-card--video-active')) {
              loadVideo();
              observer.unobserve(card);
            }
          });
        }, {
          threshold: 0.1, // El video comienza a cargar cuando está 10% visible
          rootMargin: '50px' // Comienza a cargar 50px antes de entrar al viewport
        });
        
        observer.observe(card);
      }

      // Si tiene botón de play, agregar evento click
      if (playButton) {
        playButton.addEventListener('click', loadVideo);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initMediaGridSections(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initMediaGridSections(event.target);
});

$(document).ready(function() {
  let images = $('.image-container img');
  let imageCount = images.length;
  let imageIndex = 0;
  const displayDuration = 100; // 0.5 seconds
  const transitionDuration = 0; // 0.2 seconds

  function showNextImage() {
    images.eq(imageIndex).fadeOut(transitionDuration, function() {
      imageIndex = (imageIndex + 1) % imageCount;
      images.eq(imageIndex).fadeIn(transitionDuration);
      setTimeout(showNextImage, displayDuration);
    });
  }

  images.eq(imageIndex).fadeIn(transitionDuration, function() {
    setTimeout(showNextImage, displayDuration);
  });
});

// Productos que no se venden directamente

(function() {
  'use strict';
  
  const productsToHide = ['wild-flower-ii', 'ild-flower-xi', 'oak-stitch-mirror-x-rth', 'repisero'];
  const currentPath = window.location.pathname;
  
  function replaceAddItem() {
    const shouldReplace = productsToHide.some(slug => currentPath.includes(slug));
    
    if (shouldReplace) {
      // Buscar el elemento .add_item
      const selectors = [
        '.add_item',
        'button.add_item',
        '[name="add"]',
        'button[type="submit"]',
        '.product-form__submit'
      ];
      
      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          // Verificar si ya hemos añadido el mensaje
          if (el.nextElementSibling && el.nextElementSibling.classList.contains('custom-shipping-message')) {
            return;
          }
          
          // Crear el nuevo contenido
          const customMessage = document.createElement('div');
          customMessage.className = 'custom-shipping-message';
          customMessage.innerHTML = 'These items will be able to ship upon request, please get in touch <a href="mailto:dumbo@visoproject.com">dumbo@visoproject.com</a>';
          
          // Ocultar el botón original
          el.style.display = 'none';
          
          // Insertar el mensaje después del botón (no reemplazarlo)
          el.parentNode.insertBefore(customMessage, el.nextSibling);
        });
      });
    }
  }
  
  // Ejecutar inmediatamente
  replaceAddItem();
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceAddItem);
  }
  
  // Ejecutar después de un pequeño delay por si acaso
  setTimeout(replaceAddItem, 100);
  setTimeout(replaceAddItem, 500);
  
})();

// Añadir Class a Precio Principal en página de Product

(function() {
  'use strict';
  
  function addPriceClass() {
    const productPrice = document.getElementById('product-price');
    if (productPrice && !productPrice.classList.contains('main-product-price')) {
      productPrice.classList.add('main-product-price');
    }
  }
  
  // Ejecutar inmediatamente
  addPriceClass();
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addPriceClass);
  }
  
  // Ejecutar después de un delay por si acaso
  setTimeout(addPriceClass, 100);
  
})();